import { render } from "./XiWei.vue?vue&type=template&id=408fd17c"
const script = {}

import exportComponent from "/opt/server_deploy/hnyj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__